export interface GoogleAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface Geometry {
  location: Location;
  viewport: Viewport;
}

interface Location {
  lat: number;
  lng: number;
}

interface Viewport {
  south: number;
  west: number;
  north: number;
  east: number;
}

interface OpeningHours {
  open_now: boolean;
  periods: Period[];
  weekday_text: string[];
}

interface Period {
  close: Close;
  open: Close;
}

interface Close {
  day: number;
  time: string;
  hours: number;
  minutes: number;
  nextDate: number;
}

interface Photo {
  height: number;
  html_attributions: string[];
  width: number;
}

export interface GoogleAddressValues {
  address_components: GoogleAddressComponent[];
  adr_address: string;
  formatted_address: string;
  formatted_phone_number: string;
  geometry: Geometry;
  icon: string;
  id: string;
  international_phone_number: string;
  name: string;
  opening_hours: OpeningHours;
  photos: Photo[];
  place_id: string;
  scope: string;
  types: string[];
  url: string;
  user_ratings_total: number;
  utc_offset: number;
  vicinity: string;
  website: string;
  html_attributions: any[];
}

export interface GoogleAddressObject {
  administrative_area_level_1?: string;
  country?: string;
  sublocality?: string;
  locality?: string;
  neighborhood?: string;
  political?: string;
  postal_code?: string;
  route?: string;
  street_number?: string;
  administrative_area_level_2?: string;
  administrative_area_level_3?: string;
  subpremise?: string;
}

const objectifyGoogleAddressComponents = (addressComponents: GoogleAddressComponent[] = []): GoogleAddressObject => {
  const objectifiedAddressComponents = {};

  addressComponents.forEach(component => {
    component.types.forEach(componentType => {
      if (componentType === 'administrative_area_level_1') {
        // @ts-ignore
        objectifiedAddressComponents[componentType] = component.short_name;
      } else {
        // @ts-ignore
        objectifiedAddressComponents[componentType] = component.long_name;
      }
    });
  });

  return objectifiedAddressComponents;
};

export default objectifyGoogleAddressComponents;
